import axiosInstance from '../../plugins/axios';

// Funktion um Details einer Bedingung zu erhalten
const getConditionDetails = async (conditionId) => {
  try {
    const res = await axiosInstance.get(`/conditions/${conditionId}`);
    return { data: res.data, errorMessage: null };
  } catch (error) {
    return { data: null, errorMessage: `Error fetching condition details: ${error.message}` };
  }
}

// Funktion um Details einer Frage zu erhalten
const getQuestionDetails = async (questionId) => {
  try {
    const res = await axiosInstance.get(`/questions/${questionId}`);
    return { data: res.data, errorMessage: null };
  } catch (error) {
    return { data: null, errorMessage: `Error fetching question details: ${error.message}` };
  }
}

// Funktion um eine Flag-Variable auszuwerten
const evaluateVariable = (variable, answers, allFlags) => {
  if (variable.type === 'flag') {
    const flag = allFlags.find(flag => flag.id === variable.id);
    if (!flag) {
      return { result: false, errorMessage: `Flag not found for variable id: ${variable.id}` };
    }
    return { result: variable.negated ? !flag.currentValue : flag.currentValue, errorMessage: null };
  }
  
  return { result: false, errorMessage: "Unsupported variable type" };
}

// Funktion um einen Term auszuwerten, inklusive Subterms
const evaluateTerm = (term, answers, allFlags) => {
  // Sicherstellen, dass term.variables definiert ist
  const variableResults = Array.isArray(term.variables)
    ? term.variables.map(variable => evaluateVariable(variable, answers, allFlags))
    : [];

  // Sicherstellen, dass term.subterms definiert ist
  const subtermResults = Array.isArray(term.subterms) && term.subterms.length > 0
    ? term.subterms.map(subterm => evaluateTerm(subterm, answers, allFlags))
    : [];

  const allResults = [...variableResults, ...subtermResults];
  const validResults = allResults.filter(res => res.result);

  if (term.operator === 'AND') {
    const allValid = validResults.length === allResults.length;
    return { result: allValid, errorMessage: allValid ? null : "Not all conditions met" };
  } else if (term.operator === 'OR') {
    const anyValid = validResults.length > 0;
    return { result: anyValid, errorMessage: anyValid ? null : "No valid options selected" };
  }

  return { result: false, errorMessage: "Unsupported operator" };
}

// Hauptfunktion zur Evaluation des GateKeepers
export const evaluateGateKeeper = async (questionId, answers, allFlags) => {
  console.log("Checking GateKeeper");
  console.log("QuestionId", questionId);
  
  const questionData = await getQuestionDetails(questionId);
  if (questionData.errorMessage) {
    return { nextFieldId: null, errorMessage: questionData.errorMessage };
  }

  if (!questionData.data.gateKeeper || questionData.data.gateKeeper.length === 0) {
    return { nextFieldId: questionData.data._id, errorMessage: null };
  }


  console.log("getting gate keeper GateKeeper", questionData);
  const gateKeeperDetails = await getConditionDetails(questionData.data.gateKeeper);

  if (gateKeeperDetails.errorMessage) {
    return { nextFieldId: null, errorMessage: gateKeeperDetails.errorMessage };
  }

  console.log("GateKeeperDetails", gateKeeperDetails);
  console.log("term", gateKeeperDetails.data.terms);
  for (const term of gateKeeperDetails.data.terms) {
    const { result, errorMessage } = evaluateTerm(term, answers, allFlags);
    if (!result) {
      if (questionData.data.redirectQuestion) {
        return await evaluateGateKeeper(questionData.data.redirectQuestion, answers, allFlags);
      }
      return { nextFieldId: null, errorMessage: 'End of redirection chain with unmet conditions' };
    }
  }

  return { nextFieldId: questionData.data._id, errorMessage: null };
}

export default evaluateGateKeeper;
